import {
    BB_BETFEED_FILTER_TYPE_SPORTS,
    BB_BETFEED_FILTER_TYPE_BET_TYPE,
    BB_BETFEED_FILTER_TYPE_SORT_BY,
    BB_BETFEED_LOADING_STATES,
    BB_BETFEED_FILTER_SORT_BY_INITIALSTATE,
    BB_BETFEED_FILTER_BET_TYPES_INTIALSTATE,
} from '../constants';

import { getDefaultSelectedFilters } from './utils';

/**
 * @constant {initialState}
 */
export const initialState = {
    betCards: [],
    sportName: null,
    sportSlug: null,
    loadingState: BB_BETFEED_LOADING_STATES.INIT,
    errorOccurred: false,
    errorMessage: '',
    wsSubscriptions: {
        events: [],
        markets: [],
        selections: [],
    },
    isNewBets: false,
    filter: {
        filters: {
            [BB_BETFEED_FILTER_TYPE_SPORTS.id]: {},
            [BB_BETFEED_FILTER_TYPE_BET_TYPE.id]: BB_BETFEED_FILTER_BET_TYPES_INTIALSTATE,
            [BB_BETFEED_FILTER_TYPE_SORT_BY.id]: BB_BETFEED_FILTER_SORT_BY_INITIALSTATE,
        },
        labels: {
            [BB_BETFEED_FILTER_TYPE_SPORTS.id]: BB_BETFEED_FILTER_TYPE_SPORTS.name,
            [BB_BETFEED_FILTER_TYPE_BET_TYPE.id]: BB_BETFEED_FILTER_TYPE_BET_TYPE.name,
            [BB_BETFEED_FILTER_TYPE_SORT_BY.id]: BB_BETFEED_FILTER_TYPE_SORT_BY.name,
        },
        selected: getDefaultSelectedFilters(),
        // Filter should always be collapsed by default
        // active: JSON.parse(localStorage.getItem(BB_BETFEED_FILTER_ACTIVE_KEY)) || 'sortBy',
        active: '',
    },
};
